/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProviderListItem,
    ProviderListItemFromJSON,
    ProviderListItemToJSON,
} from '../models';

export interface ApiProviderListDataPostRequest {
    body?: boolean;
}

/**
 * no description
 */
export class ProviderListApi extends runtime.BaseAPI {

    /**
     */
    async apiProviderListDataPostRaw(requestParameters: ApiProviderListDataPostRequest): Promise<runtime.ApiResponse<Array<ProviderListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/ProviderList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body as any,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderListItemFromJSON));
    }

    /**
     */
    async apiProviderListDataPost(requestParameters: ApiProviderListDataPostRequest): Promise<Array<ProviderListItem>> {
        const response = await this.apiProviderListDataPostRaw(requestParameters);
        return await response.value();
    }

}
